import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TwoFactorService } from 'src/app/deebr/service/two-factor.service';

@Component({
  selector: 'app-deebr-2fa-reset',
  template: `
    <nb-layout>
      <nb-layout-column>
        <nb-card style="max-width: 500px; margin: 50px auto;">
          <nb-card-header>Réinitialisation 2FA</nb-card-header>
          <nb-card-body>
            <nb-alert *ngIf="message" status="success">{{ message }}</nb-alert>
            <nb-alert *ngIf="error" status="danger">{{ error }}</nb-alert>
            <div *ngIf="loading" class="text-center">
                <nb-spinner></nb-spinner>
                <p>Vérification en cours...</p>
            </div>
          </nb-card-body>
          <nb-card-footer *ngIf="!loading">
            <button nbButton fullWidth status="primary" routerLink="/auth/login">Retour à la connexion</button>
          </nb-card-footer>
        </nb-card>
      </nb-layout-column>
    </nb-layout>
  `,
  styles: [`
    nb-card { border-radius: 10px; }
  `],
  standalone: false
})
export class Deebr2faResetComponent implements OnInit {

  message = '';
  error = '';
  loading = true;

  constructor(
    private route: ActivatedRoute,
    private twoFactorService: TwoFactorService,
    private router: Router
  ) { }

  ngOnInit(): void {
    const uid = this.route.snapshot.paramMap.get('uid');
    const token = this.route.snapshot.paramMap.get('token');

    if (uid && token) {
      this.twoFactorService.confirmReset(uid, token).subscribe({
        next: () => {
          this.loading = false;
          this.router.navigate(['/auth/login'], { queryParams: { reset: 'true' } });
        },
        error: () => {
          this.loading = false;
          this.error = "Le lien est invalide ou expiré.";
        }
      });
    } else {
      this.loading = false;
      this.error = "Lien incomplet.";
    }
  }
}
